var _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManagerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.84375 0.46875C2.84375 0.209875 2.63388 0 2.375 0C2.11612 0 1.90625 0.209875 1.90625 0.46875V1H2.84375V0.46875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.65625 0.46875C5.65625 0.209875 5.44638 0 5.1875 0C4.92862 0 4.71875 0.209875 4.71875 0.46875V1H5.65625V0.46875Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46875 0.46875C8.46875 0.209875 8.25888 0 8 0C7.74112 0 7.53125 0.209875 7.53125 0.46875V1H8.46875V0.46875Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2812 0.46875C11.2812 0.209875 11.0714 0 10.8125 0C10.5536 0 10.3438 0.209875 10.3438 0.46875V1H11.2812V0.46875Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0938 0.46875C14.0938 0.209875 13.8839 0 13.625 0C13.3661 0 13.1562 0.209875 13.1562 0.46875V1H14.0938V0.46875Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5312 1H14.0938V2.40625C14.0938 2.66513 13.8839 2.875 13.625 2.875C13.3661 2.875 13.1562 2.66513 13.1562 2.40625V1H11.2812V2.40625C11.2812 2.66513 11.0714 2.875 10.8125 2.875C10.5536 2.875 10.3438 2.66513 10.3438 2.40625V1H8.46875V2.40625C8.46875 2.66513 8.25887 2.875 8 2.875C7.74113 2.875 7.53125 2.66513 7.53125 2.40625V1H5.65625V2.40625C5.65625 2.66513 5.44637 2.875 5.1875 2.875C4.92863 2.875 4.71875 2.66513 4.71875 2.40625V1H2.84375V2.40625C2.84375 2.66513 2.63387 2.875 2.375 2.875C2.11613 2.875 1.90625 2.66513 1.90625 2.40625V1H0.46875C0.209875 1 0 1.20987 0 1.46875V4.4375H16V1.46875C16 1.20987 15.7901 1 15.5312 1Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 5.375,
    width: 16,
    height: 10.625,
    rx: 0.5,
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8684 12.1396H13.2213V14.4926H10.8684V12.1396Z",
    fill: "#434854"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89478 12.1396H8.24772V14.4926H5.89478V12.1396Z",
    fill: "#434854"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6842 7.5791H4.03715V9.93204H1.6842V7.5791Z",
    fill: "#434854"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58826 7.5791H8.9412V9.93204H6.58826V7.5791Z",
    fill: "#434854"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8684 7.5791H13.2213V9.93204H10.8684V7.5791Z",
    fill: "#434854"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.62355 14.1177L3.76468 12.6091L3.48194 12.2354L2.62355 13.3702L2.16506 12.764L1.88232 13.1378L2.62355 14.1177Z",
    fill: "#434854"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagerIcon);
export default __webpack_public_path__ + "static/media/manager-icon.308cde6f2f03ed5f7bdbcdc9398a3e9b.svg";
export { ForwardRef as ReactComponent };